import { TableCell, Button, Tooltip } from '@mui/material'
import { TimeSchedule, MaxConcurrentType, toMaxConcurrentType } from './EFOtapAgentNetworkSchedules.model'
import styles from './EFOtapAgentNetworkSchedules.module.scss';

const Order = [MaxConcurrentType.H, MaxConcurrentType.M, MaxConcurrentType.L] as const;

export function EFOtapAgentNetworkSchedulesCell(
  {
    day,
    hour,
    concurrentType,
    maxConcurrentTypeInfo,
    handler,
  }: Readonly<TimeSchedule>
) {

  const nextMaxConcurrentType = (curr: MaxConcurrentType): MaxConcurrentType => {
    const i = Order.indexOf(curr);
    return Order[(i + 1) % Order.length];
  }

  const onChange = (hour: number, currentConcurrentType: string) => {
    let maxConcurrentType = toMaxConcurrentType(currentConcurrentType)
    maxConcurrentType = nextMaxConcurrentType(maxConcurrentType)
    concurrentType = maxConcurrentType
    handler(hour, maxConcurrentType)
  }
  
  return (
    <TableCell className={styles.tableCellEFOtapAgentNetworkSchedules}>
      <Tooltip title={`${day} at ${String(hour).padStart(2, '0')}:00 - ${maxConcurrentTypeInfo[concurrentType as MaxConcurrentType].title} - ${maxConcurrentTypeInfo[concurrentType as MaxConcurrentType].value}`}>
        <Button
          key={`button_${day}_${hour}`}
          size="small"
          variant="contained"
          type="button"
          color={maxConcurrentTypeInfo[concurrentType as MaxConcurrentType].color }
          onClick={ () => onChange(hour, concurrentType) }
          className={ styles.hourButtonEFOtapAgentNetworkSchedules }
        >
          {concurrentType}
        </Button>
      </Tooltip>
    </TableCell>
  )
}